var count = 0;
var title = document.title;
var swRegistration;

export function changeTitle(count) {
        var newTitle = title + ' (' + count + ')';
        document.title = newTitle;
    }
export function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
export function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return "";
}
export  function checkCookie(cname) {
    var pw = getCookie(cname);
    if (pw != "") {
        return true;
    }
    return false;
} 
    // Lista qualcosa (categorie, tags ecc. )
    // e lo appende a finestra modale (modal) oppure a div specificata da elementid
export function listStuffSomewhere(what=null, where='div', elementid='') {
        $.ajax({
            type: 'POST',
            url: 'core/ajax/listStuffInModal.php',
            data: {
                what: what,
                where: where,
                elementid: elementid
            }
        }).done(function(response) {
            var jresponse = JSON.parse(response);
            if (where == "modal") {
                // Appende e mostra finestra
            } else {
                $("#"+elementid).html(jresponse.html);
            }
            console.log(jresponse);            
        }).fail(function(response){
                alert('failed')
        })
}



jQuery(function(){
    // var pageheight = $(document).height() -150;
    // $(".sidenav").css("height", pageheight);

    // Chiudo quick-stockdetails-box se clicco fuori
    $(function() {
        $('body').on('click', (e)=>{
            var container = $(".quick-stockdetails-box");
            var button = $(".stockdetails");
            if (!button.is(e.target) && button.has(e.target).length === 0) 
            {
                container.slideUp("fast");                
                container.removeClass('visible');
                container.html("");
            }            
        });
    });


    $(function() {
        $('body').on('click', '#lista-categorie', function () {
            listStuffSomewhere('categories', 'div', 'lista-stuff-show');
        });
    });

    $(function() {
        $('body').on('click', '#lista-tags', function () {
            listStuffSomewhere('tags', 'div', 'lista-stuff-show');
        });
    });

    // Enable popover everywhere
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })

    // Enable tooltip everywhere
    var tooltiptriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltiptriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    $(function () {
        $('#toggle-general-table-actions').on('click', function() {
            if ( $(this).hasClass("shown") ) {
                $('.fixed-table-toolbar .bs-bars').slideUp('fast');
                $('#toggle-general-table-actions').removeClass("shown");
            } else {
                $('.fixed-table-toolbar .bs-bars').slideDown('fast');
                $('#toggle-general-table-actions').addClass("shown");
            }
        });
    })

    $(function() {
        $(document).on('click', '.stockdetails', function () {                  
            stockDetails(this);
        })
    })

    $(function() {
        $(document).on('click', '.schooldetails', function () {                  
            schoolDetails(this);
        })
    })
    jQuery(function() {
        var elementPosition = jQuery('.fixed-table-toolbar').offset();
        if (elementPosition) {
            jQuery(window).on('scroll', function(){
                if(jQuery(window).scrollTop() > elementPosition.top){          
                    jQuery('.fixed-table-toolbar').css('box-shadow','0px 8px 6px -6px #7d7d7d');
                } else {
                    jQuery('.fixed-table-toolbar').css('box-shadow','none');
                }    
            });
        }
    })
    // window.setInterval(function(){
    //     var count = < ?php echo json_encode(getCount()) ?>;
    //     changeTitle(count);
    // }, 5000);
    
    
});
    // Web-Push
    // Public base64 to Uint
function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


const stockDetails = function (t) {        
    var e = $(t);
    // e.off('hover');       
    var pid = e.data("pid");
    $.ajax({
    type: 'POST',
    url: 'core/ajax/inventoryModalStuff.php',
    data: {
        button: "stockdetails",
        pid: pid}
    })
    .done(function(response) {                          
        var jresponse = JSON.parse(response);       
        if (jresponse.html) {                       
            let box = document.getElementsByClassName("quick-stockdetails-box");
            if (box.length == 0) {
                let el = document.createElement("div");
                el.classList.add('quick-stockdetails-box');
                el.style.cssText = 'display:none;position:fixed;top:0px;left:0px;background-color: white;z-index: 1000;padding: 10px 0px 5px 0px;border-radius: 0px 0px 10px 0px;box-shadow: 0px 0px 15px 7px #2b84c6; border: 5px solid #2b84c6;';
                document.body.appendChild(el);
                box = document.getElementsByClassName("quick-stockdetails-box");
            }             
            $(".quick-stockdetails-box").html(jresponse.html); 
            if ($(".quick-stockdetails-box").hasClass('visible')) {
                $(".quick-stockdetails-box").slideUp("fast");
            } else {
                $(".quick-stockdetails-box").addClass('visible');
            }                          
            $(".quick-stockdetails-box").slideDown("fast");
        }       
    })
}

const schoolDetails = function (t) {        
    let $e = $(t);
    // e.off('hover');       
    let orid = $e.data("orid");
    let ordertype = $e.data("ordertype");
    console.log(orid)
    console.log(ordertype)
    $.ajax({
    type: 'POST',
    url: 'core/ajax/schoolDetails.php',
    data: {
        button: "schooldetails",
        orid: orid,
        ordertype: ordertype}
    })
    .done(function(response) {                          
        var jresponse = JSON.parse(response);       
        console.log(jresponse);
        if (jresponse.html) {                       
            let box = document.getElementsByClassName("quick-stockdetails-box");
            if (box.length == 0) {
                let el = document.createElement("div");
                el.classList.add('quick-stockdetails-box');
                el.style.cssText = 'display:none;position:fixed;top:0px;left:0px;background-color: white;z-index: 1000;padding: 10px 0px 5px 0px;border-radius: 0px 0px 10px 0px;box-shadow: 0px 0px 15px 7px #2b84c6; border: 5px solid #2b84c6;';
                document.body.appendChild(el);
                box = document.getElementsByClassName("quick-stockdetails-box");
            }             
            $(".quick-stockdetails-box").html(jresponse.html); 
            if ($(".quick-stockdetails-box").hasClass('visible')) {
                $(".quick-stockdetails-box").slideUp("fast");
            } else {
                $(".quick-stockdetails-box").addClass('visible');
            }                          
            $(".quick-stockdetails-box").slideDown("fast");
        }       
    })
}


if ('serviceWorker' in navigator && 'PushManager' in window) {
    console.log('Service Worker and Push is supported');

    navigator.serviceWorker.register('sw.js')
    .then(function(swReg) {
    console.log('Service Worker is registered', swReg);

    swRegistration = swReg;
    if (Notification.permission === "granted") {
        subscribeUserToPush()
        .then(function(pushSubscription) {
            console.log('Received PushSubscription: ', JSON.stringify(pushSubscription));
            storeSubscriptionToDB(pushSubscription);
            return pushSubscription;
        });
    }
    })
    .catch(function(error) {
    console.error('Service Worker Error', error);
    });
} else {
    console.warn('Push messaging is not supported');
    // pushButton.textContent = 'Push Not Supported';
}

function subscribeUserToPush() {
    const subscribeOptions = {
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(
        'BBfR3pzFDYUTzPKpXu8zVEigunSkhzXDIc_LKnsC5qSV3JpRc589Z3zYIWcKyzNH6GitcPTygQIWCMb3EM3sSEo'
        )
    };
    return swRegistration.pushManager.subscribe(subscribeOptions);
}

function storeSubscriptionToDB(pushSubscription) {
    $.ajax({
        type: 'POST',
        url: 'core/ajax/ajax_pwa.php',
        data: {
            button: 'store',
            pushSubscription: JSON.stringify(pushSubscription)
        }
    }).done(function(response) {
        var jresponse = JSON.parse(response);       
        console.log(jresponse);            
    }).fail(function(response){
            console.log("Failed store pwa subscription")
    })
}

if (!('Notification' in window)) {
    console.log('This browser does not support notifications!');    
}

if (Notification.permission === "granted") {
    /* do our magic */
    console.log('notifiche permesse')    
    // displaySubscriptions();
} else if (Notification.permission === "blocked") {
/* the user has previously denied push. Can't reprompt. */
console.log('utente ha bloccato le notifiche')
} else {
    /* show a prompt to the user */
    Notification.requestPermission(function(status) {
        console.log('Notification permission status:', status);
    });
}


function displaySubscriptions() {
    navigator.serviceWorker.ready.then(function(reg) {
        // console.log(reg);        
        reg.pushManager.getSubscription()
        .then(function(subscription) {                              
            var endpoint = subscription.endpoint;
            var key = subscription.getKey('p256dh');
            var auth = subscription.getKey('auth');
            // console.log(endpoint);
            // console.log(key);
            // console.log(auth);
        });
    });
}
